import React from 'react'

import { Box } from '@mui/system';
import { Alert, CircularProgress } from '@mui/material';
import { StatusProps } from './Status.types';
import { extractApiErrorMessage } from '../../../../Utils/apiErrorUtils';



const Status = ({
    isLoading,
    isError,
    isSuccess,
    error,
    errorMessage,
    data,
    showEmptyInfo,
    statusDelete,
}: StatusProps) => {
    // jeśli przekazano statusDelete, to on ma pierwszeństwo
    const {
        isLoading: delLoading,
        isError: delError,
        isSuccess: delSuccess,
        error: delErr,
        data: delData,
    } = statusDelete ?? {};

    const loading = statusDelete ? delLoading : isLoading;
    const err = statusDelete ? delErr : error;
    const success = statusDelete ? delSuccess : isSuccess;
    const dat = statusDelete ? delData : data;

    const renderError = () => {
        if (errorMessage) return errorMessage;
        if (typeof err?.data === 'string') return err.data;
        if (err?.data?.errors) {
            const all = Object.values(err.data.errors).flat();
            return all.map((e, i) => <div key={i}>{String(e)}</div>);
        }
        if (err?.data?.message) return err.data.message;
        return extractApiErrorMessage(err, 'Wystąpił błąd…');
    };

    if (loading) {
        return <Box display="flex" justifyContent="center" my={2}><CircularProgress /></Box>;
    }
    if (statusDelete ? delError : isError) {
        return <Alert severity="error" sx={{ my: 2 }}>{renderError()}</Alert>;
    }
    if (statusDelete ? delSuccess : success) {
        return <Alert severity="success" sx={{ my: 2 }}>Operacja zakończona sukcesem!</Alert>;
    }
    if (showEmptyInfo && (!dat || (Array.isArray(dat) && dat.length === 0))) {
        return <Alert severity="info" sx={{ my: 2 }}>Brak danych</Alert>;
    }
    return null;
}

export default Status
